import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import workspaceApi from '@/util/workspaceApi';
import workspaceActions from '@/actions/workspaceActions';
import { ServerWorkspace } from '@shared/types';
import { mapServerWorkspaceForMember } from '@/shared/hooks/workspace/workspaceMapper';
import { useCurrentUserContext } from '../useCurrentUserContext';

interface UseAllUserWorkspacesConfig {
  enabled?: boolean;
}

const getOrganizationWorkspaces = async (): Promise<ServerWorkspace[]> => {
  const result = await workspaceApi.fetchAllWorkspacesForUser();

  return result?.data;
};

//  all the workspaces of a current user
export default function useAllUserWorkspaces(
  config?: UseAllUserWorkspacesConfig
) {
  const dispatch = useDispatch();
  const { user: currentUser } = useCurrentUserContext();
  const configEnabled = config?.enabled ?? true;

  return useQuery(
    ['workspaces', 'all'],
    async () => {
      const workspaces = await getOrganizationWorkspaces();

      return workspaces.map(mapServerWorkspaceForMember);
    },
    {
      enabled: configEnabled && !!currentUser?.apiKey,
      onSuccess: resWorkspaces => {
        dispatch(workspaceActions.setAllWorkspaceList(resWorkspaces));
      }
    }
  );
}
